<template>
  <div class="footer">
    <footer class="footer-body paddings">
      <div class="footer-nav">
        <div class="row">
          <router-link to="/">
            <div>{{ $t("result.motivaction") }}</div>
            <img src="../assets/Icons/link.svg" />
          </router-link>
          <router-link to="/faq">
            <div class="extra">{{ $t("result.faq") }}</div>
          </router-link>
          <router-link to="/contact">
            <div class="extra">{{ $t("result.contact") }}</div>
          </router-link>
        </div>
        <div class="row">
          <router-link to="/cookies-privacy">
            <div class="extra">{{ $t("result.terms") }}</div>
          </router-link>
          <router-link to="/disclaimer">
            <div class="extra">{{ $t("result.disclaimer") }}</div>
          </router-link>
        </div>
      </div>
      <div class="footer-logo">
        <router-link to="/">
          <button>
            <img class="logo" src="../assets/Icons/logo-white.svg" />
          </button>
        </router-link>
      </div>
    </footer>
  </div>
</template>

<script>
export default {};
</script>

<style lang="sass" scoped>
.footer
  background-color: $grey
  height: 90px
.footer-body
  display: flex
  max-width: 1660px
  width: 100%
  box-sizing: border-box
  margin: 0 auto
  background-color: $grey
  font-weight: 500
  z-index: 1

.footer-logo
  display: none
  justify-content: flex-end
  height: 90px
  a
    color: $white
    align-self: center
    text-decoration: none
    button
      background: transparent
      border: none
      padding: 0
      .logo
        height: 45px
        margin-right: -8px
.footer-nav
  display: flex
  justify-content: flex-start
  flex-direction: column
  width: 100%
  height: 90px
  .row
    display: flex
    height: 50%
    margin-right: 14px
    justify-content: center
    &:last-child
      margin-right: 0px
    img
      padding-left: 5px
      align-self: center
      height: 15px
    a
      display: flex
      font-size: 14px
      line-height: 15px
      color: $white
      align-self: center
      text-decoration: none
      margin-left: 14px
      &:first-child
        margin-left: 0

@media only screen and (min-width: 576px)
  .footer
    .footer-body
      .footer-logo
        display: flex !important
      .footer-nav
        .row
          display: flex
          height: 50%
          margin-right: 14px
          justify-content: center
          &:last-child
            margin-right: 0px

@media only screen and (min-width: 768px)
  .footer
      .footer-body
        .footer-nav
          flex-direction: row
          .row
            display: flex
            height: auto
            margin-right: 14px
            justify-content: center
            &:last-child
              margin-right: 0px
            a
              font-size: 18px
</style>
